exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdditionalRefundMethods{width:100%}.AdditionalRefundMethods .table{margin:0}.AdditionalRefundMethods .table td{border:none}.AdditionalRefundMethods .table td.refund-method-col,.AdditionalRefundMethods .table td.add-refund-method-col{width:35%;padding-left:0}.AdditionalRefundMethods .table td.refund-method-col button,.AdditionalRefundMethods .table td.add-refund-method-col button{width:100%}.AdditionalRefundMethods .table td.spacer-col{width:15%}.AdditionalRefundMethods .table td.refund-col{width:20%}.AdditionalRefundMethods .table td.delete-row-col{width:30%;padding-left:0;vertical-align:middle}.AdditionalRefundMethods .table .amount-input{padding:0}.AdditionalRefundMethods .table .amount-input .form-control{text-align:right}.AdditionalRefundMethods .table .Select.is-disabled>.Select-control{background-color:#e9ecef}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/invoice/components/AdditionalRefundMethods/AdditionalRefundMethods.scss
// module id = 4355
// module chunks = 0